import { AnyAction } from 'redux'
import {
  FETCH_CALENDAR,
  FETCH_SEARCH_CALENDAR,
  FETCH_USER,
  GET_TOP_BANNER,
  GET_TRACKER_URL,
  SET_ENV,
  SET_ROUTER_LOADING,
  SUBMIT_PAYMENT,
} from '../actions/types'

// host info :
export interface UserItemProps {
  name?: string
  is_verified_host?: boolean
  host_rank?: number
  response_time?: string
  response_percent?: number
  chat_response_percent?: number
  reservation_count?: number | string
  languages?: string
  last_update?: string
  about_me?: string
  is_hearing_loss?: boolean
  city?: string
  province?: string
  joined_site_at?: string
  joined_site_at_timestamp?: number
  profile_picture?: string
  houses_count?: number
  is_approved_host?: boolean
  is_mobile_approved?: boolean
  is_professional_user?: boolean
}
export interface UserStateProps {
  data: UserItemProps
  loading: boolean
}
interface UserActionProps extends UserStateProps {
  type: string
}
export const user = (
  state: UserStateProps = { data: {}, loading: false },
  { type, data, loading }: UserActionProps,
): UserStateProps => {
  switch (type) {
    case FETCH_USER:
      return { ...state, data, loading }

    default:
      return state
  }
}

export type CalendarStateType = any

export const calendar = (
  state: CalendarStateType = null,
  action: AnyAction,
) => {
  switch (action.type) {
    case FETCH_CALENDAR:
      return { ...state, ...action.payload }

    default:
      return state
  }
}

export const SearchCalendar = (
  state: CalendarStateType = null,
  action: AnyAction,
) => {
  switch (action.type) {
    case FETCH_SEARCH_CALENDAR:
      return { ...state, ...action.payload }

    default:
      return state
  }
}
// Footer Links :
export interface FooterLinksProps {
  'ویلاهای شمال'?: [
    {
      description: string
      link: string
    },
  ]
  'ویلاهای جنوب'?: [
    {
      description: string
      link: string
    },
  ]
  'ویلاهای اطراف تهران'?: [
    {
      description: string
      link: string
    },
  ]
  سایر?: [
    {
      description: string
      link: string
    },
  ]
}

export interface SubmitPayment {
  data: { credit: number; pgw: number }
  loading: boolean
}
export const submitPayment = (
  state: SubmitPayment = { data: { credit: 0, pgw: 0 }, loading: false },
  action,
) => {
  switch (action.type) {
    case SUBMIT_PAYMENT:
      return {
        data: action.data,
        loading: action.loading,
      }

    default:
      return state
  }
}

export interface TopBannerProps {
  type?: string
  data: any
  loading: boolean
}
export const topBanner = (
  state: TopBannerProps = { data: null, loading: false },
  { type, data, loading }: TopBannerProps,
): TopBannerProps => {
  switch (type) {
    case GET_TOP_BANNER:
      return { data, loading }

    default:
      return state
  }
}

export interface TrackerUrlProps {
  type?: string
  data: any
  loading: boolean
}
export const trackerUrl = (
  state: TrackerUrlProps = { data: null, loading: false },
  { type, data, loading }: TrackerUrlProps,
): TopBannerProps => {
  switch (type) {
    case GET_TRACKER_URL:
      return { data, loading }

    default:
      return state
  }
}
